// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found_wrapper__qLe6j","walletIcon":"not-found_walletIcon__6TBWm"};